"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Page = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var _withResponsiveMode = require("@fluentui/react/lib/utilities/decorators/withResponsiveMode");

var React = _interopRequireWildcard(require("react"));

var _useTheme = require("../hooks/useTheme");

var _getResponsiveMaxWidth = require("../styling/getResponsiveMaxWidth");

var _stylingConstants = require("../styling/stylingConstants");

var getClassNames = (0, _react.classNamesFunction)();

var PageBase = function PageBase(_ref) {
  var maxWidth = _ref.maxWidth,
      automationId = _ref.automationId,
      className = _ref.className,
      styles = _ref.styles,
      children = _ref.children;
  var theme = (0, _useTheme.useTheme)();
  var classes = getClassNames(styles, {
    theme: theme,
    maxWidth: maxWidth
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("main", {
    "data-automation-id": automationId,
    className: (0, _react.css)('ms-Page', className, classes.root),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _react.css)('ms-Page--scroll', classes.content),
      children: children
    })
  });
};

var Page = (0, _react.styled)(PageBase, function (_ref2) {
  var palette = _ref2.theme.palette,
      _ref2$maxWidth = _ref2.maxWidth,
      maxWidth = _ref2$maxWidth === void 0 ? (0, _getResponsiveMaxWidth.getResponsiveMaxWidth)(_withResponsiveMode.ResponsiveMode.large) : _ref2$maxWidth;
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'center',
      backgroundColor: palette.neutralLighterAlt,
      height: '100%',
      width: '100%',
      overflow: 'auto',
      '-webkit-overflow-scrolling': 'touch'
    },
    content: {
      boxSizing: 'border-box',
      position: 'relative',
      flex: "0 1 ".concat(_stylingConstants.gridUnit * 177, "px"),
      maxWidth: '100%',
      padding: "".concat(_stylingConstants.gridUnit * 3, "px"),
      selectors: (0, _defineProperty2.default)({}, "@media (max-width: ".concat(maxWidth, "px)"), {
        padding: "".concat(_stylingConstants.gridUnit * 2, "px")
      })
    }
  };
});
exports.Page = Page;